import { UsePortalSelector } from "..";

const UseTerritories = () => UsePortalSelector((state) => state.entity.territories);

export { UseTerritories };
